import { XIcon } from "@heroicons/react/solid";
import React from "react";
import { Link, Outlet } from "react-router-dom";
import AuthBg from "../../assets/images/5.png";
import TendoLogo from "../../assets/images/tendo-logo.png";
import Wave from "../../assets/images/wave-pattern-light.svg";
import {
  setToggleLogin,
  setToggleRegister,
} from "../../redux/actions/appActions";

type Props = {};

const Auth = (props: Props) => {
  return (
    <div className="lg:h-screen w-screen p-0 m-0 font-openSan relative">
      <div className="flex w-full h-full">
        <div className="w-1/2 hidden md:flex md:justify-center md:items-center bg-tendo">
          <div
            className="relative w-full h-full hidden md:flex md:justify-center md:items-center"
            style={{
              backgroundImage: `url(${Wave})`,
              backgroundPosition: "center",
              backgroundSize: "cover",
              backgroundRepeat: "no-repeat",
            }}
          >
            <div className="absolute top-0 left-0 right-0 mt-3 mx-3 px-8">
              <div className="mt-8 w-16 rounded-md bg-gray-300 p-4 border-2 border-gray-400">
                <Link
                  to="/"
                  onClick={() => {
                    setToggleLogin(false);
                    setToggleRegister(false);
                  }}
                >
                  <XIcon className="cursor-pointer" />
                </Link>
              </div>
            </div>
            <div className="min-w-full mx-36 p-8">
              <div className="flex flex-col">
                <div className="flex flex-row mb-12">
                  <div className="py-12 xl:mr-16 mr-8 my-9">
                    <img
                      src={TendoLogo}
                      alt="tendo logo"
                      height={52}
                      width={52}
                      className="rounded-md"
                    />
                    <p className="text-5xl text-tendo-blue leading-snug font-semibold my-5">
                      Start your online business with zero capital 😎
                    </p>
                    <p className="text-base font-semibold text-sokoGreen">
                      Earn with Tendo in 3 easy steps
                    </p>
                    <p className="flex items-center space-x-4">
                      <span className="text-xl font-semibold">Browse 📲</span>
                      <span className="text-xl font-semibold">Share 🤲🏾 </span>
                      <span className="text-xl font-semibold">Earn 🤑</span>
                    </p>
                  </div>

                  <div
                    className="rounded-md hidden xl:block"
                    style={{
                      width: 540,
                      backgroundImage: `url(${AuthBg})`,
                      backgroundPosition: "center",
                      backgroundSize: "cover",
                      backgroundRepeat: "no-repeat",
                    }}
                  ></div>
                </div>
              </div>
            </div>

            <div className="absolute bottom-0 mb-5 mx-auto text-center">
              <span className="text-sokoBlue text-sm font-semibold">
                &copy; {new Date().getFullYear()} Tendo Soko Technologies, Inc.
              </span>
            </div>
          </div>
        </div>
        <div className="w-full min-h-screen overflow-y-scroll lg:bg-white bg-sokoBlue lg:w-1/2 flex justify-center items-center relative px-6 md:px-36">
          <div className="flex flex-col w-full">
            <div className="lg:hidden block mx-auto mb-6 md:mt-0 mt-5">
              <img
                src={TendoLogo}
                alt="tendo logo"
                height={52}
                width={52}
                className="rounded-md"
              />
            </div>
            <Outlet />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Auth;
